// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, recordOf } from "@altostra/type-validations";
import { string, number, boolean } from "@altostra/type-validations/lib/primitives";

export const isDashboardConversionAttributionDashboardAppGroupIdCampaignCanvasMetadataResult = objectOf({
  campaigns: recordOf({
    key: string,
    value: objectOf({
      id: string,
      actions: arrayOf(
        objectOf({
          message_variations: arrayOf(
            objectOf({
              id: string,
              name: string,
              _type: string,
            })
          ),
        })
      ),
      conversion_behaviors: arrayOf(
        objectOf({
          id: string,
          pbws: number,
          _type: string,
        })
      ),
      name: string,
    }),
  }),
  canvases: recordOf({
    key: string,
    value: objectOf({
      id: string,
      conversion_behaviors: arrayOf(
        objectOf({
          id: string,
          pbws: number,
          _type: string,
        })
      ),
      variations: arrayOf(
        objectOf({
          id: string,
          send_percentage: number,
          name: string,
          first_step_ids: arrayOf(string),
          is_control: boolean,
          marked_as_deleted: boolean,
          api_variation_id: string,
        })
      ),
      name: string,
    }),
  }),
  canvas_steps: recordOf({
    key: string,
    value: objectOf({
      id: string,
      name: string,
    }),
  }),
});
